import { render, staticRenderFns } from "./SelectedProducts.vue?vue&type=template&id=0ae85f57&scoped=true&"
import script from "./SelectedProducts.vue?vue&type=script&lang=js&"
export * from "./SelectedProducts.vue?vue&type=script&lang=js&"
import style0 from "./SelectedProducts.vue?vue&type=style&index=0&id=0ae85f57&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae85f57",
  null
  
)

export default component.exports